import { Input } from "reactstrap";
import {
  WorkOrderSourceType,
  // WorkOrderSourceTypeLabelMap,
  WorkOrderStatus,
  workOrderStatusMap,
} from "features/WorkOrders/constants/work-order.constants";
import type { WorkOrderListParams } from "features/WorkOrders/services/WorkOrderService";
export type WorkOrderListFiltersState = {
  status: WorkOrderStatus | "";
  sourceTypes: WorkOrderSourceType[];
  sourceId: number | "";
  createdBy: number | "";
  createdFrom: string;
  createdTo: string;
};

export function emptyWorkOrderListFilters(): WorkOrderListFiltersState {
  return {
    status: "",
    sourceTypes: [],
    sourceId: "",
    createdBy: "",
    createdFrom: "",
    createdTo: "",
  };
}

const WO_STATUS_FILTER_ORDER = [
  WorkOrderStatus.NEW,
  WorkOrderStatus.IN_PROGRESS,
  WorkOrderStatus.ON_HOLD,
  WorkOrderStatus.READY_FOR_BILLING,
  WorkOrderStatus.COMPLETED,
  WorkOrderStatus.CANCELLED,
] as const;

export function workOrderListFiltersToListParams(
  f: WorkOrderListFiltersState,
): Partial<WorkOrderListParams> {
  return {
    ...(f.status ? { status: f.status } : {}),
    ...(f.sourceTypes.length ? { sourceType: f.sourceTypes.join(",") } : {}),
    ...(f.sourceId !== "" && Number.isFinite(f.sourceId) && f.sourceId > 0
      ? { sourceId: f.sourceId }
      : {}),
    ...(f.createdBy !== "" && Number.isFinite(f.createdBy) && f.createdBy > 0
      ? { createdBy: f.createdBy }
      : {}),
    ...(f.createdFrom ? { createdFrom: f.createdFrom } : {}),
    ...(f.createdTo ? { createdTo: f.createdTo } : {}),
  };
}

export function countWorkOrderListFiltersActive(
  f: WorkOrderListFiltersState,
): number {
  let n = 0;
  if (f.status) n += 1;
  if (f.sourceTypes.length) n += 1;
  if (f.sourceId !== "") n += 1;
  if (f.createdBy !== "") n += 1;
  if (f.createdFrom) n += 1;
  if (f.createdTo) n += 1;
  return n;
}

export type WorkOrderListFiltersProps = {
  filters: WorkOrderListFiltersState;
  onChange: (next: WorkOrderListFiltersState) => void;
};

export default function WorkOrderListFilters({
  filters,
  onChange,
}: WorkOrderListFiltersProps) {
  const patch = (partial: Partial<WorkOrderListFiltersState>) =>
    onChange({ ...filters, ...partial });

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Input
        type="select"
        className="form-select"
        style={{ width: 150 }}
        value={filters.status}
        onChange={(e) =>
          patch({ status: e.target.value as WorkOrderStatus | "" })
        }
      >
        <option value="">All statuses</option>
        {WO_STATUS_FILTER_ORDER.map((s) => (
          <option key={s} value={s}>
            {workOrderStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
    </div>
  );
}
